import { Duration } from '@/models/chat.model'

export function getTotalChatDuration(durations: Duration[]): number {
  if (!durations?.length) return 0
  return durations.reduce((chatTotal, duration) => {
    const totalForOperator = duration.periods.reduce((total, period) => {
      if (period.endTime === undefined) return total
      return total + (period.endTime - period.startTime)
    }, 0)

    return chatTotal + totalForOperator
  }, 0)
}
